
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[profile]/replies",
      function () {
        return require("private-next-pages/[profile]/replies.js");
      }
    ]);
  